export type VTimePickerViewMode = 'hour' | 'minute' | 'second'
